import React, { useEffect, useContext, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { PopupMenu } from '../lib/reusable/PopupMenu';
import { MenuButton } from '../lib/reusable/MenuButton';
import HeaderProduct from '../lib/typography/HeaderProduct';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';
import { getFeatures } from '../utils/getFeatures';

export const Navigation = (props) => {
  const { closeMenu, header } = props;
  const [placeState] = useContext(PlaceStoreContext);
  const history = useHistory();
  const { path } = useRouteMatch();

  const [hasLive, setHasLive] = useState(false);

  useEffect(() => {
    const hasFeatures = !placeState?.place?.features !== undefined;
    if (hasFeatures) {

      const { hasLive } = getFeatures(placeState.place.features);
      setHasLive(hasLive);
    } else {
      hasLive && setHasLive(false);
    }
  }, [placeState]);

  const goToLive = () => {
    !header && closeMenu();
    history.push('/live');
  };

  // const goToServices = () => {
  //   !header && closeMenu();
  //   history.push('/live/services');
  // };

  // const goToTv = () => {
  //   !header && closeMenu();
  //   history.push('/live/tv');
  // };

  const goToMenuManagement = () => {
    !header && closeMenu();
    history.push('/manage');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
      {hasLive && <MenuButton action={goToLive} name="LIVE" header={header} active={path === '/live'} />}
      {/* <MenuButton action={goToServices} name="SERVICES" header={header} active={path === '/live/services'} /> */}
      {/* <MenuButton action={goToTv} name="TV" header={header} active={path === '/live/tv'} /> */}
      <MenuButton action={goToMenuManagement} name="MENU" header={header} active={path.includes('/manage')} />
    </div>
  )
}

const MainMenuPopup = (props) => {
  const { isVisible, closeMenu } = props;

  const handleClick = () => {
    setTimeout(() => isVisible && closeMenu(), 300);
  };

  useEffect(() => {
    window.addEventListener('click', handleClick, false);
    return () => {
      window.removeEventListener('click', handleClick, false);
    };
  });

  if (!isVisible) return null;
  return (
    <PopupMenu
      isVisible={isVisible}
      style={{ top: '60px', left: '0px' }}
      arrowStyle={{ top: '40px', left: '10px' }}
      rotation={90}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <HeaderProduct
          name="PAGES"
          color="#000000"
          size="1rem"
          style={{ textAlign: 'left', marginLeft: '2px', marginBottom: '8px' }}
        />
        <Navigation closeMenu={closeMenu} />
      </div>
    </PopupMenu>
  );
};

export { MainMenuPopup };
